import { FilterSelect } from "../components/FilterSelect.jsx";
// Reconstructed from the supplied production build; original component names were unavailable.
import {
  ArrowLeftIcon,
  BookOpenIcon,
  BrainIcon,
  ClockIcon,
  CodeIcon,
  CpuIcon,
  DatabaseIcon,
  DownloadIcon,
  ExternalLinkIcon,
  EyeIcon,
  FunnelIcon,
  Gamepad2Icon,
  GithubIcon,
  GlobeIcon,
  HeartIcon,
  React,
  SearchIcon,
  ShieldIcon,
  SmartphoneIcon,
  StarIcon,
  TrendingUpIcon,
  WifiIcon,
  motion,
} from "../vendor/runtime.js";
import { SERVER_URL } from "../config.js";
const BlogPage = () => {
  const [a, n] = React.useState(""),
    [i, l] = React.useState("All"),
    c = () => {
      window.history.back();
    },
    u = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
        },
      },
    },
    m = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    f = [
      "All",
      "Web Development",
      "Mobile Apps",
      "AI/ML",
      "IoT",
      "Blockchain",
      "Cybersecurity",
      "Game Development",
      "Data Science",
      "Cloud Computing",
    ],
    x = [
      {
        id: 1,
        title: "Smart Healthcare Management System with AI Diagnosis",
        excerpt:
          "Complete hospital management system with AI-powered disease prediction, patient monitoring, and telemedicine features. Perfect for CSE final year major project.",
        description:
          "A comprehensive healthcare platform featuring patient management, appointment scheduling, AI-based symptom analysis, and real-time health monitoring dashboard.",
        techStack: ["React.js", "Node.js", "MongoDB", "Python", "TensorFlow", "Socket.io"],
        author: "CSE Project Team",
        date: "2025-01-15",
        complexity: "Advanced",
        duration: "6-8 months",
        category: "AI/ML",
        image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop",
        tags: ["Healthcare", "AI", "Machine Learning", "React", "Final Year"],
        views: 3420,
        downloads: 856,
        likes: 234,
        rating: 4.8,
        featured: true,
        sourceCode: true,
        liveDemo: true,
        documentation: true,
        suitableFor: ["CSE", "IT", "ECE"],
        keyFeatures: [
          "AI-powered disease prediction",
          "Real-time patient monitoring",
          "Telemedicine integration",
          "Electronic health records",
          "Appointment scheduling system",
        ],
      },
      {
        id: 2,
        title: "E-Commerce Platform with Advanced Analytics",
        excerpt:
          "Full-stack e-commerce solution with inventory management, payment gateway integration, and business intelligence dashboard for CSE major project.",
        description:
          "Modern e-commerce platform with microservices architecture, real-time analytics, recommendation engine, and mobile-responsive design.",
        techStack: ["Angular", "Spring Boot", "MySQL", "Redis", "Docker", "AWS"],
        author: "BCA Project Group",
        date: "2025-01-12",
        complexity: "Intermediate",
        duration: "4-6 months",
        category: "Web Development",
        image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=250&fit=crop",
        tags: ["E-commerce", "Full Stack", "Analytics", "Spring Boot"],
        views: 2890,
        downloads: 642,
        likes: 187,
        rating: 4.6,
        featured: true,
        sourceCode: true,
        liveDemo: true,
        documentation: true,
        suitableFor: ["CSE", "IT", "BCA"],
        keyFeatures: [
          "Multi-vendor support",
          "Advanced search and filtering",
          "Real-time inventory tracking",
          "Payment gateway integration",
          "Business analytics dashboard",
        ],
      },
      {
        id: 4,
        title: "Blockchain-Based Voting System",
        excerpt:
          "Secure digital voting platform using blockchain technology ensuring transparency and immutability. Perfect computer science final year project.",
        description:
          "Decentralized voting application with blockchain backend, voter authentication, real-time results, and audit trail functionality.",
        techStack: ["Solidity", "Web3.js", "React", "Ethereum", "IPFS", "MetaMask"],
        author: "Blockchain Developers",
        date: "2025-01-08",
        complexity: "Advanced",
        duration: "6-8 months",
        category: "Blockchain",
        image: SERVER_URL + "/images/1749480099715-615041181.webp",
        tags: ["Blockchain", "Voting", "Security", "Ethereum", "Decentralized"],
        views: 2756,
        downloads: 489,
        likes: 156,
        rating: 4.7,
        featured: false,
        sourceCode: true,
        liveDemo: true,
        documentation: true,
        suitableFor: ["CSE", "IT"],
        keyFeatures: [
          "Blockchain-based security",
          "Voter authentication system",
          "Real-time vote counting",
          "Transparent audit trail",
          "Mobile-friendly interface",
        ],
      },
      {
        id: 5,
        title: "AI-Powered Stock Market Prediction System",
        excerpt:
          "Machine learning application for stock price prediction with technical analysis, portfolio management, and risk assessment features.",
        description:
          "Advanced trading platform with ML algorithms for price prediction, sentiment analysis from news, and automated trading strategies.",
        techStack: ["Python", "TensorFlow", "Django", "PostgreSQL", "Pandas", "Plotly"],
        author: "Data Science Team",
        date: "2025-01-05",
        complexity: "Advanced",
        duration: "7-9 months",
        category: "AI/ML",
        image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=250&fit=crop",
        tags: ["AI", "Stock Market", "Machine Learning", "Finance", "Python"],
        views: 3890,
        downloads: 723,
        likes: 267,
        rating: 4.8,
        featured: false,
        sourceCode: true,
        liveDemo: true,
        documentation: true,
        suitableFor: ["CSE", "IT", "Data Science"],
        keyFeatures: [
          "ML-based price prediction",
          "Sentiment analysis from news",
          "Portfolio optimization",
          "Risk assessment tools",
          "Real-time market data",
        ],
      },
      {
        id: 6,
        title: "Cybersecurity Incident Response Platform",
        excerpt:
          "Comprehensive security platform for threat detection, incident management, and automated response with SIEM integration.",
        description:
          "Enterprise-grade cybersecurity platform with threat intelligence, incident tracking, automated response, and compliance reporting.",
        techStack: ["Java", "Spring Security", "Elasticsearch", "Kibana", "Docker", "Kubernetes"],
        author: "Cybersecurity Team",
        date: "2025-01-03",
        complexity: "Advanced",
        duration: "8-10 months",
        category: "Cybersecurity",
        image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400&h=250&fit=crop",
        tags: ["Security", "SIEM", "Incident Response", "Java", "Enterprise"],
        views: 2234,
        downloads: 334,
        likes: 145,
        rating: 4.6,
        featured: false,
        sourceCode: true,
        liveDemo: false,
        documentation: true,
        suitableFor: ["CSE", "IT", "Cybersecurity"],
        keyFeatures: [
          "Real-time threat detection",
          "Automated incident response",
          "SIEM integration",
          "Compliance reporting",
          "Threat intelligence feeds",
        ],
      },
      {
        id: 7,
        title: "Cross-Platform Mobile App for Food delivery",
        excerpt:
          "Complete food delivery solution with customer app, delivery partner app, restaurant dashboard, and admin panel.",
        description:
          "Multi-platform food delivery ecosystem with real-time tracking, payment integration, rating system, and analytics dashboard.",
        techStack: ["Flutter", "Firebase", "Node.js", "MongoDB", "Stripe", "Google Maps"],
        author: "Mobile App Team",
        date: "2025-01-01",
        complexity: "Intermediate",
        duration: "5-6 months",
        category: "Mobile Apps",
        image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop",
        tags: ["Mobile App", "Flutter", "Food Delivery", "Cross Platform"],
        views: 3567,
        downloads: 891,
        likes: 223,
        rating: 4.7,
        featured: false,
        sourceCode: true,
        liveDemo: true,
        documentation: true,
        suitableFor: ["CSE", "IT", "BCA"],
        keyFeatures: [
          "Multi-platform support",
          "Real-time order tracking",
          "Multiple payment options",
          "Rating and review system",
          "Analytics dashboard",
        ],
      },
      {
        id: 8,
        title: "Cloud-Based Document Management System",
        excerpt:
          "Enterprise document management platform with version control, collaboration tools, and advanced search capabilities.",
        description:
          "Scalable cloud solution for document storage, sharing, collaboration with OCR, full-text search, and workflow automation.",
        techStack: ["ASP.NET Core", "Azure", "SQL Server", "Angular", "SignalR", "OCR"],
        author: "Cloud Solutions Team",
        date: "2024-12-28",
        complexity: "Intermediate",
        duration: "4-5 months",
        category: "Cloud Computing",
        image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=400&h=250&fit=crop",
        tags: ["Cloud", "Document Management", "Azure", "Enterprise", "ASP.NET"],
        views: 1987,
        downloads: 456,
        likes: 134,
        rating: 4.5,
        featured: false,
        sourceCode: true,
        liveDemo: true,
        documentation: true,
        suitableFor: ["CSE", "IT"],
        keyFeatures: [
          "Cloud-based storage",
          "Version control system",
          "Collaborative editing",
          "OCR text extraction",
          "Advanced search capabilities",
        ],
      },
      {
        id: 9,
        title: "Multiplayer Online Game with Real-time Chat",
        excerpt:
          "2D/3D multiplayer game with real-time communication, matchmaking, leaderboards, and in-game purchases system.",
        description:
          "Full-featured online gaming platform with multiplayer support, chat system, user profiles, achievements, and monetization features.",
        techStack: ["Unity", "C#", "Node.js", "Socket.io", "MongoDB", "WebRTC"],
        author: "Game Dev Studio",
        date: "2024-12-25",
        complexity: "Advanced",
        duration: "8-12 months",
        category: "Game Development",
        image: "https://images.unsplash.com/photo-1552820728-8b83bb6b773f?w=400&h=250&fit=crop",
        tags: ["Game Development", "Unity", "Multiplayer", "Real-time", "C#"],
        views: 2845,
        downloads: 567,
        likes: 189,
        rating: 4.6,
        featured: false,
        sourceCode: true,
        liveDemo: true,
        documentation: true,
        suitableFor: ["CSE", "IT", "Game Design"],
        keyFeatures: [
          "Multiplayer gameplay",
          "Real-time chat system",
          "Leaderboards and achievements",
          "In-game purchase system",
          "Cross-platform compatibility",
        ],
      },
    ],
    p = x.filter((w) => {
      const N =
          w.title.toLowerCase().includes(a.toLowerCase()) ||
          w.excerpt.toLowerCase().includes(a.toLowerCase()) ||
          w.tags.some((C) => C.toLowerCase().includes(a.toLowerCase())),
        T = i === "All" || w.category === i;
      return N && T;
    }),
    g = x.filter((w) => w.featured),
    b = (w) =>
      ({
        "Web Development": <GlobeIcon className={"w-4 h-4"} />,
        "Mobile Apps": <SmartphoneIcon className={"w-4 h-4"} />,
        "AI/ML": <BrainIcon className={"w-4 h-4"} />,
        IoT: <WifiIcon className={"w-4 h-4"} />,
        Blockchain: <DatabaseIcon className={"w-4 h-4"} />,
        Cybersecurity: <ShieldIcon className={"w-4 h-4"} />,
        "Game Development": <Gamepad2Icon className={"w-4 h-4"} />,
        "Data Science": <TrendingUpIcon className={"w-4 h-4"} />,
        "Cloud Computing": <CpuIcon className={"w-4 h-4"} />,
      })[w] || <CodeIcon className={"w-4 h-4"} />,
    y = (w) => {
      switch (w) {
        case "Beginner":
          return "bg-green-100 text-green-800";
        case "Intermediate":
          return "bg-yellow-100 text-yellow-800";
        case "Advanced":
          return "bg-red-100 text-red-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    };
  return (
    <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
      <div
        style={{
          display: "none",
        }}
      >
        <h1>{"Codebruh"}</h1>
        <h1>{"Final Year Projects for Computer Science and Engineering"}</h1>
        <h2>{"CSE Final Year Project with Source Code"}</h2>
        <h3>{"Major Project for CSE Final Year Students"}</h3>
        <h4>{"BCA Last Year Project Ideas"}</h4>
        <h5>{"ECE Final Year Major Projects"}</h5>
        <h6>{"Computer Science Projects Final Year"}</h6>
      </div>
      <section
        className={
          "bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-900 relative overflow-hidden py-12 lg:py-16"
        }
      >
        <div className={"absolute inset-0 opacity-10"}>
          <div
            className={
              "absolute top-0 left-0 w-full h-full bg-gradient-to-br from-cyan-400/20 via-blue-500/20 to-purple-600/20"
            }
          />
          <div
            className={
              "absolute top-1/4 left-1/4 w-20 h-20 lg:w-32 lg:h-32 bg-white/5 rounded-full blur-2xl animate-pulse"
            }
          />
          <div
            className={
              "absolute bottom-1/4 right-1/4 w-16 h-16 lg:w-24 lg:h-24 bg-indigo-400/10 rounded-full blur-xl animate-pulse delay-1000"
            }
          />
        </div>
        <div className={"relative max-w-6xl mx-auto px-3 sm:px-4"}>
          <motion.div
            initial={{
              opacity: 0,
              x: -20,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.5,
            }}
            className={"mb-4 sm:mb-6 lg:mb-8"}
          >
            <button
              onClick={c}
              className={
                "group inline-flex items-center px-3 sm:px-4 lg:px-6 py-2 lg:py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white rounded-lg lg:rounded-xl hover:bg-white/20 transition-all duration-300 text-xs sm:text-sm lg:text-base font-medium shadow-lg hover:shadow-xl"
              }
            >
              <ArrowLeftIcon
                className={
                  "w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 mr-1.5 sm:mr-2 group-hover:-translate-x-1 transition-transform duration-300"
                }
              />
              {"Go Back"}
            </button>
          </motion.div>
          <div className={"text-center"}>
            <motion.div
              initial={"hidden"}
              animate={"visible"}
              variants={u}
              className={"text-white"}
            >
              <div
                className={
                  "w-12 h-12 sm:w-14 sm:h-14 lg:w-20 lg:h-20 mx-auto mb-4 lg:mb-6 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl lg:rounded-2xl flex items-center justify-center shadow-2xl"
                }
              >
                <CodeIcon className={"w-6 h-6 sm:w-7 sm:h-7 lg:w-10 lg:h-10 text-white"} />
              </div>
              <h1
                className={
                  "text-xl sm:text-2xl lg:text-4xl font-bold mb-3 lg:mb-4 bg-gradient-to-r from-white to-slate-200 bg-clip-text text-transparent"
                }
              >
                {"Final Year Projects Hub"}
              </h1>
              <p
                className={
                  "text-sm sm:text-base lg:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed mb-4 lg:mb-6"
                }
              >
                {
                  "Discover premium CSE, ECE & BCA final year projects with source code, documentation, and live demos. Perfect for computer science major projects."
                }
              </p>
              <div
                className={"flex flex-wrap justify-center gap-2 text-xs lg:text-sm text-slate-400"}
              >
                <span className={"bg-white/10 px-3 py-1 rounded-full"}>{"Codebruh"}</span>
                <span className={"bg-white/10 px-3 py-1 rounded-full"}>
                  {"CSE Final Year Projects"}
                </span>
                <span className={"bg-white/10 px-3 py-1 rounded-full"}>{"ECE Major Projects"}</span>
                <span className={"bg-white/10 px-3 py-1 rounded-full"}>
                  {"BCA Last Year Projects"}
                </span>
                <span className={"bg-white/10 px-3 py-1 rounded-full"}>
                  {"Source Code Included"}
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <section
        className={"max-w-6xl mx-auto px-3 sm:px-4 py-6 sm:py-8 -mt-6 sm:-mt-8 relative z-10"}
      >
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={u}
          className={
            "bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-xl border border-slate-100 p-4 sm:p-6 lg:p-8"
          }
        >
          <div className={"flex flex-col lg:flex-row gap-4 lg:gap-6"}>
            <div className={"flex-1 relative"}>
              <SearchIcon
                className={
                  "absolute left-3 sm:left-4 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4 sm:w-5 sm:h-5"
                }
              />
              <input
                type={"text"}
                placeholder={"Search final year projects, CSE projects, ECE projects..."}
                value={a}
                onChange={(w) => n(w.target.value)}
                className={
                  "w-full pl-10 sm:pl-12 pr-4 py-2 sm:py-3 text-sm sm:text-base border-2 border-slate-200 rounded-lg lg:rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
                }
              />
            </div>
            <div className={"relative"}>
              <FilterSelect label="Category"
                value={i}
                onChange={(w) => l(w.target.value)}
                className={
                  "pl-10 sm:pl-12 pr-8 py-2 sm:py-3 text-sm sm:text-base border-2 border-slate-200 rounded-lg lg:rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all bg-white appearance-none cursor-pointer"
                }
              >
                {f.map((w) => (
                  <option key={w} value={w}>
                    {w}
                  </option>
                ))}
              </FilterSelect>
            </div>
          </div>
        </motion.div>
      </section>
      <main className={"max-w-6xl mx-auto px-3 sm:px-4 pb-8 lg:pb-12"}>
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={m}
          className={"space-y-6 sm:space-y-8 lg:space-y-12"}
        >
          {i === "All" && a === "" && (
            <motion.div variants={u}>
              <div className={"flex items-center gap-3 mb-4 sm:mb-6"}>
                <div
                  className={
                    "w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg flex items-center justify-center"
                  }
                >
                  <StarIcon className={"w-4 h-4 sm:w-5 sm:h-5 text-white"} />
                </div>
                <h2 className={"text-lg sm:text-xl lg:text-2xl font-bold text-slate-900"}>
                  {"Featured Final Year Projects"}
                </h2>
              </div>
              <div
                className={"grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 mb-8 lg:mb-12"}
              >
                {g.map((w) => (
                  <div
                    key={w.id}
                    className={
                      "bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-xl border border-slate-100 overflow-hidden group hover:shadow-2xl transition-all duration-300 cursor-pointer"
                    }
                  >
                    <div className={"relative overflow-hidden"}>
                      <img
                        src={w.image}
                        alt={`${w.title} - Final Year Project`}
                        className={
                          "w-full h-32 sm:h-40 lg:h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                        }
                      />
                      <div
                        className={
                          "absolute top-3 left-3 bg-gradient-to-r from-orange-500 to-red-500 text-white px-2 py-1 rounded-full text-xs font-semibold"
                        }
                      >
                        {"Featured"}
                      </div>
                      <div
                        className={
                          "absolute top-3 right-3 flex items-center gap-1 bg-black/50 text-white px-2 py-1 rounded-full text-xs"
                        }
                      >
                        <StarIcon className={"w-3 h-3 fill-current"} />
                        {w.rating}
                      </div>
                    </div>
                    <div className={"p-4 sm:p-6"}>
                      <div className={"flex items-center gap-2 mb-2 sm:mb-3"}>
                        <span
                          className={
                            "flex items-center gap-1 text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-full font-medium"
                          }
                        >
                          {b(w.category)}
                          {w.category}
                        </span>
                        <span
                          className={`text-xs px-2 py-1 rounded-full font-medium ${y(w.complexity)}`}
                        >
                          {w.complexity}
                        </span>
                      </div>
                      <h3
                        className={
                          "text-base sm:text-lg font-bold text-slate-900 mb-2 sm:mb-3 line-clamp-2"
                        }
                      >
                        {w.title}
                      </h3>
                      <p
                        className={
                          "text-xs sm:text-sm text-slate-600 mb-3 sm:mb-4 text-justify line-clamp-3"
                        }
                      >
                        {w.excerpt}
                      </p>
                      <div className={"flex flex-wrap gap-1 mb-3"}>
                        {w.techStack.slice(0, 4).map((N, T) => (
                          <span
                            key={T}
                            className={
                              "text-xs bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded-full"
                            }
                          >
                            {N}
                          </span>
                        ))}
                        {w.techStack.length > 4 && (
                          <span className={"text-xs text-slate-400"}>
                            {"+"}
                            {w.techStack.length - 4}
                            {" more"}
                          </span>
                        )}
                      </div>
                      <div className={"flex items-center justify-between mb-3"}>
                        <div className={"flex items-center gap-3"}>
                          <div className={"flex items-center gap-1"}>
                            <EyeIcon className={"w-3 h-3 text-slate-400"} />
                            <span className={"text-xs text-slate-500"}>{w.views}</span>
                          </div>
                          <div className={"flex items-center gap-1"}>
                            <DownloadIcon className={"w-3 h-3 text-slate-400"} />
                            <span className={"text-xs text-slate-500"}>{w.downloads}</span>
                          </div>
                          <div className={"flex items-center gap-1"}>
                            <HeartIcon className={"w-3 h-3 text-slate-400"} />
                            <span className={"text-xs text-slate-500"}>{w.likes}</span>
                          </div>
                        </div>
                        <div className={"text-xs text-slate-500"}>
                          {"Duration: "}
                          {w.duration}
                        </div>
                      </div>
                      <div className={"flex items-center gap-2"}>
                        {w.sourceCode && (
                          <button
                            className={
                              "flex items-center gap-1 bg-slate-900 text-white px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-slate-800 transition-colors"
                            }
                          >
                            <GithubIcon className={"w-3 h-3"} />
                            {"Source Code"}
                          </button>
                        )}
                        {w.liveDemo && (
                          <button
                            className={
                              "flex items-center gap-1 bg-indigo-600 text-white px-3 py-1.5 rounded-lg text-xs font-medium hover:bg-indigo-700 transition-colors"
                            }
                          >
                            <ExternalLinkIcon className={"w-3 h-3"} />
                            {"Live Demo"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          )}
          <motion.div variants={u}>
            <div className={"flex items-center justify-between mb-4 sm:mb-6"}>
              <div className={"flex items-center gap-3"}>
                <div
                  className={
                    "w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center"
                  }
                >
                  <CodeIcon className={"w-4 h-4 sm:w-5 sm:h-5 text-white"} />
                </div>
                <h2 className={"text-lg sm:text-xl lg:text-2xl font-bold text-slate-900"}>
                  {i === "All" ? "All Final Year Projects" : `${i} Projects`}
                </h2>
              </div>
              <span
                className={
                  "text-xs sm:text-sm text-slate-500 bg-slate-100 px-2 sm:px-3 py-1 rounded-full"
                }
              >
                {p.length}
                {" projects"}
              </span>
            </div>
            <div
              className={"grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 lg:gap-8"}
            >
              {p.map((w) => (
                <motion.div
                  key={w.id}
                  variants={u}
                  className={
                    "bg-white rounded-lg sm:rounded-xl lg:rounded-2xl shadow-xl border border-slate-100 overflow-hidden group hover:shadow-2xl transition-all duration-300 cursor-pointer"
                  }
                >
                  <div className={"relative overflow-hidden"}>
                    <img
                      src={w.image}
                      alt={`${w.title} - CSE Final Year Project`}
                      className={
                        "w-full h-28 sm:h-32 lg:h-40 object-cover group-hover:scale-105 transition-transform duration-500"
                      }
                    />
                    {w.featured && (
                      <div
                        className={
                          "absolute top-2 left-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-2 py-0.5 rounded-full text-xs font-semibold"
                        }
                      >
                        {"Featured"}
                      </div>
                    )}
                    <div
                      className={
                        "absolute top-2 right-2 flex items-center gap-1 bg-black/50 text-white px-2 py-1 rounded-full text-xs"
                      }
                    >
                      <StarIcon className={"w-3 h-3 fill-current"} />
                      {w.rating}
                    </div>
                  </div>
                  <div className={"p-3 sm:p-4 lg:p-6"}>
                    <div className={"flex items-center gap-2 mb-2"}>
                      <span
                        className={
                          "flex items-center gap-1 text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full font-medium"
                        }
                      >
                        {b(w.category)}
                        {w.category}
                      </span>
                      <span
                        className={`text-xs px-2 py-0.5 rounded-full font-medium ${y(w.complexity)}`}
                      >
                        {w.complexity}
                      </span>
                    </div>
                    <h3
                      className={
                        "text-sm sm:text-base lg:text-lg font-bold text-slate-900 mb-2 line-clamp-2"
                      }
                    >
                      {w.title}
                    </h3>
                    <p
                      className={"text-xs sm:text-sm text-slate-600 mb-3 text-justify line-clamp-3"}
                    >
                      {w.excerpt}
                    </p>
                    <div className={"flex flex-wrap gap-1 mb-3"}>
                      {w.techStack.slice(0, 3).map((N, T) => (
                        <span
                          key={T}
                          className={
                            "text-xs bg-indigo-50 text-indigo-600 px-2 py-0.5 rounded-full"
                          }
                        >
                          {N}
                        </span>
                      ))}
                      {w.techStack.length > 3 && (
                        <span className={"text-xs text-slate-400"}>
                          {"+"}
                          {w.techStack.length - 3}
                        </span>
                      )}
                    </div>
                    <div className={"flex items-center justify-between mb-3"}>
                      <div className={"flex items-center gap-2"}>
                        <div className={"flex items-center gap-1"}>
                          <EyeIcon className={"w-3 h-3 text-slate-400"} />
                          <span className={"text-xs text-slate-500"}>{w.views}</span>
                        </div>
                        <div className={"flex items-center gap-1"}>
                          <DownloadIcon className={"w-3 h-3 text-slate-400"} />
                          <span className={"text-xs text-slate-500"}>{w.downloads}</span>
                        </div>
                      </div>
                      <div className={"flex items-center gap-1"}>
                        <ClockIcon className={"w-3 h-3 text-slate-400"} />
                        <span className={"text-xs text-slate-500"}>{w.duration}</span>
                      </div>
                    </div>
                    <div className={"space-y-2 mb-3"}>
                      <div className={"text-xs text-slate-500"}>
                        <span className={"font-medium"}>{"Suitable for:"}</span>{" "}
                        {w.suitableFor.join(", ")}
                      </div>
                      <div className={"text-xs text-slate-500"}>
                        <span className={"font-medium"}>{"Author:"}</span> {w.author}
                      </div>
                    </div>
                    <div className={"flex items-center gap-2"}>
                      {w.sourceCode && (
                        <button
                          className={
                            "flex items-center gap-1 bg-slate-900 text-white px-2 py-1 rounded-md text-xs font-medium hover:bg-slate-800 transition-colors"
                          }
                        >
                          <GithubIcon className={"w-3 h-3"} />
                          {"Code"}
                        </button>
                      )}
                      {w.liveDemo && (
                        <button
                          className={
                            "flex items-center gap-1 bg-indigo-600 text-white px-2 py-1 rounded-md text-xs font-medium hover:bg-indigo-700 transition-colors"
                          }
                        >
                          <ExternalLinkIcon className={"w-3 h-3"} />
                          {"Demo"}
                        </button>
                      )}
                      {w.documentation && (
                        <button
                          className={
                            "flex items-center gap-1 bg-green-600 text-white px-2 py-1 rounded-md text-xs font-medium hover:bg-green-700 transition-colors"
                          }
                        >
                          <BookOpenIcon className={"w-3 h-3"} />
                          {"Docs"}
                        </button>
                      )}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
            {p.length === 0 && (
              <div className={"text-center py-12 lg:py-16"}>
                <div
                  className={
                    "w-16 h-16 mx-auto mb-4 bg-slate-100 rounded-full flex items-center justify-center"
                  }
                >
                  <SearchIcon className={"w-8 h-8 text-slate-400"} />
                </div>
                <h3 className={"text-lg font-bold text-slate-900 mb-2"}>{"No Projects Found"}</h3>
                <p className={"text-slate-600 text-sm"}>
                  {
                    "Try adjusting your search terms or category filter to find CSE, ECE, or BCA final year projects."
                  }
                </p>
              </div>
            )}
          </motion.div>
          <motion.div
            variants={u}
            className={"bg-gradient-to-r from-slate-50 to-indigo-50 rounded-2xl p-6 lg:p-8 mt-12"}
          >
            <div className={"max-w-4xl mx-auto"}>
              <h2 className={"text-2xl lg:text-3xl font-bold text-slate-900 mb-6 text-center"}>
                {"Complete Final Year Project Solutions"}
              </h2>
              <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8"}>
                <div className={"bg-white rounded-xl p-6 shadow-lg"}>
                  <div
                    className={
                      "w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center mb-4"
                    }
                  >
                    <CodeIcon className={"w-6 h-6 text-white"} />
                  </div>
                  <h3 className={"text-lg font-bold text-slate-900 mb-2"}>
                    {"CSE Final Year Projects"}
                  </h3>
                  <p className={"text-sm text-slate-600"}>
                    {
                      "Computer Science Engineering projects with complete source code, documentation, and implementation guides for major project requirements."
                    }
                  </p>
                </div>
                <div className={"bg-white rounded-xl p-6 shadow-lg"}>
                  <div
                    className={
                      "w-12 h-12 bg-gradient-to-br from-green-500 to-teal-500 rounded-lg flex items-center justify-center mb-4"
                    }
                  >
                    <CpuIcon className={"w-6 h-6 text-white"} />
                  </div>
                  <h3 className={"text-lg font-bold text-slate-900 mb-2"}>
                    {"ECE Major Projects"}
                  </h3>
                  <p className={"text-sm text-slate-600"}>
                    {
                      "Electronics and Communication Engineering final year projects with hardware integration, IoT solutions, and embedded systems."
                    }
                  </p>
                </div>
                <div className={"bg-white rounded-xl p-6 shadow-lg"}>
                  <div
                    className={
                      "w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg flex items-center justify-center mb-4"
                    }
                  >
                    <BookOpenIcon className={"w-6 h-6 text-white"} />
                  </div>
                  <h3 className={"text-lg font-bold text-slate-900 mb-2"}>
                    {"BCA Last Year Projects"}
                  </h3>
                  <p className={"text-sm text-slate-600"}>
                    {
                      "Bachelor of Computer Applications final year project ideas with modern web technologies and mobile app development."
                    }
                  </p>
                </div>
              </div>
              <div className={"bg-white rounded-xl p-6 lg:p-8 shadow-lg"}>
                <h3 className={"text-xl font-bold text-slate-900 mb-4"}>
                  {"Why Choose Our Final Year Projects?"}
                </h3>
                <div className={"grid grid-cols-1 md:grid-cols-2 gap-6"}>
                  <div>
                    <h4 className={"font-semibold text-slate-900 mb-2"}>
                      {"✅ Complete Source Code"}
                    </h4>
                    <p className={"text-sm text-slate-600 mb-4"}>
                      {
                        "Every project includes full source code with detailed comments and modular structure for easy understanding and modification."
                      }
                    </p>
                    <h4 className={"font-semibold text-slate-900 mb-2"}>
                      {"✅ Comprehensive Documentation"}
                    </h4>
                    <p className={"text-sm text-slate-600 mb-4"}>
                      {
                        "Technical documentation, user manuals, and project reports formatted according to university standards."
                      }
                    </p>
                  </div>
                  <div>
                    <h4 className={"font-semibold text-slate-900 mb-2"}>
                      {"✅ Live Demonstrations"}
                    </h4>
                    <p className={"text-sm text-slate-600 mb-4"}>
                      {
                        "Working demos hosted online to showcase project functionality and help you understand the complete workflow."
                      }
                    </p>
                    <h4 className={"font-semibold text-slate-900 mb-2"}>
                      {"✅ Modern Technologies"}
                    </h4>
                    <p className={"text-sm text-slate-600"}>
                      {
                        "Projects built with latest frameworks and technologies including React, Node.js, Python, Flutter, and more."
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div variants={u} className={"bg-white rounded-2xl p-6 lg:p-8 shadow-lg"}>
            <h3 className={"text-xl font-bold text-slate-900 mb-4 text-center"}>
              {"Popular Project Categories"}
            </h3>
            <div className={"flex flex-wrap justify-center gap-2"}>
              {[
                "Final Year Project",
                "CSE Final Year Projects",
                "ECE Major Projects",
                "BCA Last Year Project",
                "Computer Science Projects",
                "Major Project CSE",
                "Final Year Projects with Source Code",
                "Engineering Final Year Projects",
                "IT Final Year Projects",
                "Software Engineering Projects",
                "Web Development Projects",
                "Mobile App Projects",
                "AI ML Projects",
                "IoT Projects",
                "Blockchain Projects",
                "Cybersecurity Projects",
              ].map((w, N) => (
                <span
                  key={N}
                  className={
                    "text-xs bg-gradient-to-r from-indigo-50 to-purple-50 text-indigo-700 px-3 py-1 rounded-full border border-indigo-200 hover:bg-indigo-100 transition-colors cursor-pointer"
                  }
                >
                  {w}
                </span>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </main>
      <footer className={"bg-slate-900 text-white py-8 lg:py-12 mt-12"}>
        <div className={"max-w-6xl mx-auto px-4 text-center"}>
          <div className={"mb-6"}>
            <h4 className={"text-lg font-bold mb-2"}>
              {"Ready to Start Your Final Year Project?"}
            </h4>
            <p className={"text-slate-300 text-sm"}>
              {
                "Browse our collection of premium CSE, ECE, and BCA final year projects with complete source code and documentation."
              }
            </p>
          </div>
          <div className={"flex flex-wrap justify-center gap-4 text-sm text-slate-400"}>
            <span>{"© 2025 Codebruh.in"}</span>
            <span>{"•"}</span>
            <span>{"Premium Quality Projects"}</span>
            <span>{"•"}</span>
            <span>{"Source Code Included"}</span>
            <span>{"•"}</span>
            <span>{"24/7 Support"}</span>
          </div>
        </div>
      </footer>
    </div>
  );
};
export { BlogPage };
